import React from 'react';
import Label from '@discover-ui/label';
import Button from '@discover-ui/button';
import usePage from '@discover-data/stores/hooks/page/usePage';
import Pre from './pre';

export default function Paging() {
  const { limit, nextPage, resetPage } = usePage();

  return (
    <>
      <Label>Paging</Label>
      <div className="flex flex-row items-center gap-2 self-stretch">
        <Pre>
          Limit: <code>{limit}</code>
        </Pre>
        <Button kind="outline" scale="sm" onClick={() => resetPage()}>
          Reset
        </Button>
        <Button scale="sm" onClick={() => nextPage()}>
          Next Page
        </Button>
      </div>
    </>
  );
}
